// src/hooks/useOfflineSync.js
import { useEffect, useState } from 'react';
import { onSyncStatus, syncNow } from '../services/syncEngine';
import { getPendingCount } from '../services/offlineQueue';

export default function useOfflineSync() {
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);
  const [total, setTotal] = useState(0);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    let mounted = true;
    getPendingCount().then((c) => mounted && setPending(c));

    const unsub = onSyncStatus(({ pending, syncing, total }) => {
      if (!mounted) return;
      setPending(pending);
      setSyncing(syncing);
      setTotal(total || 0);
    });

    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      mounted = false;
      unsub();
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return { pending, syncing, total, online, syncNow };
}
